import { notification } from 'antd';

/* eslint-disable */
export const Notification = {
  info: (title = '', description = '') =>
    notification.info({
      message: title,
      description: description,
    }),
  error: (title = '', description = '') =>
    notification.error({
      message: title,
      description: description,
    }),
  success: (title = '', description = '') =>
    notification.success({
      message: title,
      description: description,
    }),
  warning: (title = '', description = '') =>
    notification.warning({
      message: title,
      description: description,
    }),
};
